/* Elody – aggiunta al carrello dai blocchi della home e dalla barra spedizione */
(function(){
  if (window.__elodyUi) return;
  window.__elodyUi = true;

  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-ely-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var ids = String(btn.getAttribute('data-ely-add')).split(',').filter(Boolean);
    if (!ids.length) return;
    var items = ids.map(function(id){ return { id: Number(id), quantity: 1 }; });
    var label = btn.innerHTML;
    btn.disabled = true;

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(r){ if (!r.ok) throw r; return r.json(); })
    .then(function(){
      btn.classList.add('is-done');
      if (btn.hasAttribute('data-ely-done')) btn.innerHTML = btn.getAttribute('data-ely-done');
      var onCartPage = document.body.classList.contains('template-cart') || /\/cart\/?$/.test(location.pathname);
      if (onCartPage) { location.reload(); return; }
      if (typeof window.refreshCart === 'function') { window.refreshCart(); }
      else { location.href = root + 'cart'; }
      setTimeout(function(){ btn.disabled = false; btn.classList.remove('is-done'); btn.innerHTML = label; }, 2200);
    })
    .catch(function(){
      btn.disabled = false;
      location.href = root + 'cart';
    });
  });
})();
